<template>
  <div class="middle">
    <a id="AboutUs"></a>
    <div class="story">
      <h1>Our story comes from the heart of my very own home.</h1>
      <img src="../assets/pic_juliana.jpg"/>
      <h2>I am 24 years old, and have a 22 year old brother with ADHD and Autism. His name is Michael. Making Authentic Friendships (MAF) are also my brothers initials. He inspired this initiative. He is very lonely due to his lack of social skills and ability to make friends.</h2>
      <h2>I just recently finished my MBA at Sacred Heart University in Fairfield, CT, but reside on Long Island. I am passionate about bettering the lives with those with autism and other special needs, and plan to dedicate my entire life to doing so.</h2>
    </div>
    <!-- <div class="inTheKnow">
      <h1>Want to stay in the know?</h1>
      <h2>Sign up for our email list if you want to be the first to know about app status, launch dates, and available beta testing groups.</h2>
      <emailBar/>
    </div> -->
    <div class="inTheKnow">
      <h1>Getting Started</h1>
      <h2>You can register and sign in using our buttons in the header! It's that easy.</h2>
      <h2>New! <a href="https://apps.apple.com/us/app/making-authentic-friendships/id1538026980" target="_blank">iOS</a> and <a href="https://play.google.com/store/apps/details?id=com.maf.makingauthenticfriendships" target="_blank">Android</a> apps.</h2>
      <h2>Have questions about the app? <a href="./MAF-FAQs.pdf" target="_blank">Visit our FAQs.</a></h2>
    </div>
  </div>
</template>

<script>
export default {
  name: "middle",
  components: {}
}
</script>

<style scoped>
.middle {
  outline: none;
  text-align: center;
  width:100%;
}

h1 {
  font-family: 'chunk';
  font-size: 60px;
  font-weight: inherit;
}

h2 a {
  color: white !important;
}

.story {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 0;
}

.story h1 {
  width: 65%;
  color:#F06377;
}
.story h2 {
  font-size: 25px;
  color:#232323;
  width: 70%;
}

.inTheKnow {
  background-image:url("../assets/bg_intheknow.jpg");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.inTheKnow h1 {
  color: white;
}

.inTheKnow h2 {
  width: 62%;
  margin-left: 20%;
  color:white;
  font-size: 30px;
  font-family: 'futura';
  font-weight: inherit;
  letter-spacing: 1px;
}
@media screen and (max-width:1024px){
  .story h1 {
    font-weight:bolder;
    font-size:3vmax ;
    width:80%;
  }
  .story h2 {
    font-size:2vmax ;
    width:80%;
  }
  .story img {
    width:60%;
  }
  .inTheKnow h1 {
    font-size:3.5vmax; 
    width:90%;
    margin-left:5%;
    letter-spacing: 0px;
  }
  .inTheKnow h2 {
    font-size:2vmax;
    width:85%;
    margin-left:7.5%;
    letter-spacing: 0px;
  }
}
</style>